// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FzqUFMBwDUoBDV {
  align-self: center;
  width: 100%;
  margin: var(--ds-space-050, 4px);
  border-bottom: 1px solid var(--ds-border, #091e4224);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pinnedCardDivider": `FzqUFMBwDUoBDV`
};
export default ___CSS_LOADER_EXPORT___;
